export default __webpack_public_path__ + "static/media/Corporate_1.13dcc70b.png";